import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useFetch from "../../hooks/useFetch";
import { FuelStashBalance, DebitFuelStash }  from "./FuelStashUtil"; 
import PaymentNoticeBanner from "./PaymentNoticeBanner";
import FullCompanyDetails from "../../components/FullCompanyDetails";
import CompanyInfo from "../../components/CompanyInfo";
import CompanyBankInfo from "../../components/CompanyBankInfo";
import SubscriptionTnC from "../../components/SubscriptionTnC";
import PDGiftRedeem from "./modules/gift/PDGiftRedeem";
import PDGiftIt from "./modules/gift/PDGiftIt";

const productConfig = {
    GenZUdaan: {
        label: "GenZUdaan",
        subtitle: "365 Days Access - Director, FindItLocal, StreakGifts, Hustlers, MiniERP, SAKSHAM MSME Kit, FoundHer, HerKart",
    },
    AnvayaEhssas: {
        label: "AnvayaEhssas",
        subtitle: "365 Days Subscription - PurpleDoor, LifeReplay, Pulse, ScorePlus Individual, Mood/FanRatings",
    },  
    AnvayaGrowth: {
        label: "AnvayaGrowth",
        subtitle: "365 Days Subscription - PurpleDoor, LifeReplay, Pulse, ScorePlus Individual, Mood/FanRatings, GrowthLoop",
    },      
    PurpleDoor: {
        label: "PurpleDoor",
        subtitle: "90 Days Full Access Plan",
    },
    LifeReplays: {
        label: "LifeReplays",
        subtitle: "1 Year Access Plan",
    },
    Pulse: {
        label: "Pulse",
        subtitle: "1 Year Access Plan",
    },  
    GrowthLoop: {
        label: "GrowthLoop",
        subtitle: "6 months Child Behavioral Assessment, Monitoring and Analysis OS",
    }, 
    ScorePlus: {
        label: "ScorePlus",
        subtitle: "Personal, Couple & Family Performance Analytics",
    },  
    CarePassPub: {
        label: "CarePassPub",
        subtitle: "Annual Pass to Continuous Data-Centric Health Companionship for Patients and Public",
    }, 
    CarePassMed: {
        label: "CarePass",
        subtitle: "Annual Pass to Continuous Data-Centric Health Companionship for Doctors and Health Advisors",
    },     
    Reunion: {
        label: "Reunion",
        subtitle: "Reunion Single Use Community Group Game Pass for 1-20 Users",
    },
    DigitalBoutique: {
        label: "DigitalBoutique",
        subtitle: "Digital Boutique Orientation Membership & Service Fee",
    },
    DirectorEnrollment: {
        label: "DirectorEnrollment",
        subtitle: "1 Year Digital Master Boutique Owbership Platform Service Fee",
    },
    CoordinatorEnrollment: {
        label: "CoordinatorEnrollment",
        subtitle: "1 Year Digital Sub Boutique Owbership Platform Service Fee",
    },
    MerchantEnrollment: {
        label: "MerchantEnrollment",
        subtitle: "1 Year Premium Merchant Platform Service Fee",
    },
    PehchaanSetuChannel: {
        label: "PehchaanSetuChannel",
        subtitle: "180 days PehcgaanSetu Platform Usage Charge as Channel Individual Member",
    },
    PehchaanSetuCircle: {
        label: "PehchaanSetuCircle",
        subtitle: "180 days PehcgaanSetu Platform Usage Charge as Circle Individual Member",
    },
    StreakGift: {
        label: "StreakGift",
        subtitle: "Streak Rewards Toys (Physical) Sponsorship",
    },
    VocalForLocalDisplay: {
        label: "VocalForLocalDisplay",
        subtitle: "VocalForLocal Advanced Features Enablement",
    },
    Foundher: {
        label: "Foundher",
        subtitle: "FoundHer Level 1 Orintation and Fair Usage Annual Commitment Fee",
    },
    SHGAddon: {
        label: "SHGAddon",
        subtitle: "FoundHer SHG Member Addon - Annual Subscription",
    },
    MiniERPNoEDI: {
        label: "MiniERPNoEDI",
        subtitle: "365 days Accounting, Inventory, Sales-Purchase, Attendance Features without EDI",
    },
    MiniERPEDI: {
        label: "MiniERPEDI",
        subtitle: "180 days Local Business EDI with Counter Sales Memo (Electronic Data Interchange) Module",
    },
    EComStore: {
        label: "EComStore",
        subtitle: "180 days Online Cart, Mini Order Management & Provate Store Management",
    }, 
    BestieStreaks: {
        label: "BestieStreaks",
        subtitle: "60 Days Paid Subscription of Bestie Module Games",
    },        
    NaboraExibitorPass: {
        label: "NaboraExibitorPass",
        subtitle: "Digital Exhibition Pass",
    },
    AddOnInstant: {
        label: "AddOn",
        subtitle: "Non Subscription AddOn Service Fee",
    },

    AnvayaCarePlus: {
        label: "AnvayaCarePlus",
        subtitle: "365 Days Subscription - PurpleDoor, LifeReplay, Pulse, ScorePlus with Doctor",
    },
    AnvayaCompleteCare: {
        label: "AnvayaCompleteCare",
        subtitle: "365 Days Subscription - PurpleDoor, LifeReplay, Pulse, ScorePlus, AI Insights, Analytics+, PharmaPerks*",
    },
    AnvayaGrowth: {
        label: "AnvayaGrowth",
        subtitle: "365 Days Subscription - PurpleDoor, LifeReplay, Pulse, ScorePlus, GrowthLoop",
    },
    ToolKitSeed: {
        label: "ToolKitSeed",
        subtitle: "365 Days Subscription - DMD, FindItLocal, HerKart, MSME Kit, PehchhanSetu",
    },
    ToolKitHer: {
        label: "ToolKitHer",
        subtitle: "180 Days Subscription - FindItLocal, Streaks, Founder, HerKart, MSME Kit, PehchhanSetu",
    },
    ToolKitEarlyGrowth: {
        label: "ToolKitEarlyGrowth",
        subtitle: "180 Days Subscription - FindItLocal, Streaks, Founder, HerKart, FiLTV, MSME Kit, PehchhanSetu",
    },
    ToolKitLeap: {
        label: "ToolKitLeap",
        subtitle: "90 Days Subscription - FindItLocal, Streaks, Founder, HerKart, FiLTV, MSME Kit, PehchhanSetu, MiniERP",
    },
    ToolKitFull: {
        label: "ToolKitFull",
        subtitle: "90 Days Subscription - DMD, FindItLocal, Streaks, Founder, HerKart, FiLTV, MSME Kit, PehchhanSetu, MiniERP, MSME Module",
    },

    OtherServices: {
        label: "OtherServices",
        subtitle: "1 Year Access Plan for Other Services",
    },
};

export default function PDBuySubscription({ user }) {
    const authState = useSelector((state) => state.authReducer);
    const token = authState?.token;
    const [fetchData] = useFetch();

    const userId = authState.user?._id;
    const [product, setProduct] = useState("PurpleDoor");  
    const [countryCode, setCountryCode] = useState("IN");
    const [directorCode, setDirecotorCode] = useState("");
    const [coordinatorCode, setCoordinatorCode] = useState("");
    const [influencerCode, setInfluencerCode] = useState("");
    const [institutionCode, setInstitutionCode] = useState("");

    const userCountry = authState?.user?.country;
    const isCountryMissing = !userCountry;
    const userState = authState?.user?.state;
    const isStateMissing = !userState;

    const [giftedByName, setGiftedByName] = useState("");
    const [giftedByCode, setGiftedByCode] = useState("");
    const [giftMsg, setGiftmsg] = useState("");
    const [isGifted, setIsGifted] = useState(false);
    const [giftedDate, setGiftedDate] = useState(null);

    const [invoice, setInvoice] = useState(null);
    const [taxMeta, setTaxMeta] = useState([]);
    const [disablePurchase, setDisablePurchase] = useState(false);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(null);
    const [message, setMessage] = useState({ text: '', type: '' });
    const showMessage = (text, type = "success") => {
        setMessage({ text, type });
    };

    const [config, setConfig] = useState(null);
    const [balanceOK, setBalanceOK] = useState(false);
    const [walletBalance, setWalletBalance] = useState(0);
    const [paymentError, setPaymentError] = useState("");
    const [activeSubscription, setActiveSubscription] = useState(null);

    const [showCompanyDetails, setShowCompanyDetails] = useState(false);
    const [showTnC, setShowTnC] = useState(false);

    const [showGiftForm, setShowGiftForm] = useState(false);
    const [showGiftRedeem, setShowGiftRedeem] = useState(false);

    const [errorMsg, setErrorMsg] = useState("");

    const loadMyOnboarding = async () => {
        try {
            setMyOnboarding(null);
            const requestConfig = {
                url: "/pd/onboarding/my",
                method: "post",
                data: {
                    userId: user?._id
                },
                headers: {Authorization: token}
            };
            const response = await fetchData(requestConfig,{ silent: true });

            if (response?.status) {
                setDirecotorCode(response.directorCode);
                setCoordinatorCode(response.coordinatorCode);
                setInfluencerCode(response.influencerCode);
                setInstitutionCode(response.institutionCode);
            }
        } catch (error) {
            console.error("Load Directors Porfile Error:", error);
        }
    };

    useEffect(() => {
        if (!token || !user?._id ) return;

        loadMyOnboarding();
    }, [user?._id, token]);

    const loadMySubscription = async () => {
        try {
            setActiveSubscription(null);
            const requestConfig = {
                url: "/pd/subscription/my",
                method: "post",
                data: {
                    userId: user?._id
                },
                headers: {Authorization: token}
            };
            const response = await fetchData(requestConfig,{ silent: true });

            if (response?.status) {

                const now = new Date();
                const active = (response.data || []).filter(item => {
                        const isActive = item.isActive;
                        const notExpired = new Date(item.endDate) > now;
                        const dbProduct = item.product?.trim();
                        const selectedProduct = product?.trim();
                        const matchesProduct = dbProduct === selectedProduct;
                        return isActive && notExpired && matchesProduct;
                    })
                    .sort((a, b) =>
                        new Date(b.endDate) - new Date(a.endDate)
                    )[0];
                setActiveSubscription(active || null);
            }
        } catch (error) {
            console.error("Load Subscription Error:", error);
        }
    };

    useEffect(() => {
        if (!token || !user?._id || !product) return;

        loadMySubscription();
    }, [user?._id, token, product]);
    

    useEffect(() => {
        if (!token) return;
        loadConfig();
    }, [token]);

    const loadConfig = async () => {
        try {
            const requestConfig = {
                url: "/pd/subscription/config",
                method: "get",
                headers: { Authorization: token },
            };
            const response = await fetchData(requestConfig, { silent: true });
            if (!response?.status || !response?.config) return;
            setConfig(response.config);
            const defaultCountry =
                response.config.countries.find(c => c.code === "IN") ||
                response.config.countries?.[0];
            if (!defaultCountry || !product) return;
            setCountryCode(defaultCountry.code);
        } catch (error) {
            console.error("Fetch Config Error:", error);
            showMessage("Failed to load config", "error");
        }
    };
    const selectedCountry = config?.countries?.find(c => c.country === userCountry);
    const getCountryMeta = (countryName, config) => {
        return config?.countries?.find(
            c => c.country.toLowerCase() === countryName?.toLowerCase()
        );
    };

    const productData = config?.products?.[product];
    const country = getCountryMeta(authState?.user?.country, config);
    const currency = country?.currency;
    const baseAmount = productData?.prices?.[currency] ?? 0;
    const taxRate = productData?.tax?.[country?.code] ?? 0;
    const totalAmount = baseAmount * (1 + taxRate);

    const checkBalance = async () => {
        setMessage({ text: "", type: "" });
        setSuccess(null);
        setLoading(true);
        try {
            const walletRes = await fetchData({
                url: "/walletbalance",
                method: "get",
                headers: { Authorization: token }
            });
            const balance = Number(walletRes?.balanceAmount?.$numberDecimal ?? 0);
            setWalletBalance(balance);
            if (balance < totalAmount) {
                showMessage(
                    `Insufficient FuelStash balance. Available: ${balance}. Please top up.`,
                    "error"
                );
                setBalanceOK(false);
                setDisablePurchase(true);
            } else {
                setBalanceOK(true);
                setDisablePurchase(false);
            }
        } catch (error) {
            showMessage(
                typeof error === "string"
                    ? error
                    : "Unexpected error occurred in Check Balance",
                "error"
            );
            setBalanceOK(false);
            setDisablePurchase(true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!userId || !token) return;
        checkBalance();
    }, [userId, token]);


    // API to Buy
    const buy = async () => {
        if (loading) return;

        setMessage({ text: "", type: "" });
        setSuccess(null);

        if ( product !== "ScorePlus" && activeSubscription && activeSubscription.product === product) {
            showMessage("You already have an active subscription for this product.", "error");
            return;
        }

        if (!user?._id) {
            showMessage("User information unavailable", "error");
            return;
        }

        if (!config) {
            showMessage("Configuration not loaded", "error");
            return;
        }

        try {
            const requestConfig = {
                url: "/pd/subscription/buy",
                method: "post",
                data: { 
                    product: product,
                    userId: user._id,
                    userCode: user.think5whyscode,
                    userName: user.name,
                    state: user.state,
                    country: user.country,
                    countryCode,
                    currency,
                    taxRate,
                    baseAmount,
                    totalAmount,
                    isGifted: false,
                    giftedByName,
                    giftedByCode,
                    giftedDate,
                    giftMsg,
                    institutionCode,
                    coordinatorCode,
                    directorCode,
                    influencerCode,
                },
                headers: { Authorization: token },
            };
            const response = await fetchData(requestConfig, { silent: true });
            if (response?.alreadySubscribed) {
                setActiveSubscription(response.data);
                setTaxMeta(response.taxMeta || {});
                showMessage(response.message,"success");
                return;
            }
            if (!response?.status) {
                showMessage(response?.message || "Failed to Buy Subscription","error");
                return;
            }
            setSuccess(response.message || "Subscription purchased successfully");
            setTaxMeta(response.taxMeta || {});
            setActiveSubscription(false);
            setDisablePurchase(true);
            setInvoice(response.invoice);

            fetchWalletBalance();
            await loadMySubscription();

        } catch (error) {
            setActiveSubscription(true);
            setDisablePurchase(true);

            await loadMySubscription();

        } finally {
            setLoading(false);
        }
    };

    const [agreements, setAgreements] = useState({
        nonRefundable: true,
        technicalGlitches: true,
        contestRules: true,
        contestEligibility: true,
        directorCoordinatorKyc: true,
    });

    const allChecked = Object.values(agreements).every(Boolean);

    const handleAgreementChange = (e) => {
    const { name, checked } = e.target;

    setAgreements((prev) => ({
            ...prev,
            [name]: checked,
        }));
    };

    return (
        <div className="p-4">
            <div className="bg-[#111827] border border-gray-800 rounded-xl p-4">
                <div className="mb-4">
                    <label className="block text-xs text-gray-400 mb-1">
                        Select Product
                    </label>
                    <select
                        value={product}
                        onChange={(e) => setProduct(e.target.value)}
                        className="w-full bg-[#1f2937] border border-gray-700 rounded px-2 py-1 text-xs"
                    >
                        <option value="GenZUdaan">GenZUdaan</option>
                        <option value="AnvayaEhssas">AnvayaEhssas</option>
                        <option value="AnvayaGrowth">AnvayaGrowth</option>
                        <option value="PurpleDoor">PurpleDoor</option>
                        <option value="LifeReplays">LifeReplays</option>
                        <option value="Pulse">Pulse</option>
                        <option value="GrowthLoop">GrowthLoop</option>
                        <option value="ScorePlus">ScorePlus</option>
                        <option value="CarePassPub">CarePassPub</option>
                        <option value="CarePassMed">CarePassMed</option>
                        <option value="Reunion">Reunion</option>
                        <option value="DigitalBoutique">DigitalBoutique</option>
                        <option value="DirectorEnrollment">DirectorEnrollment</option>
                        <option value="CoordinatorEnrollment">CoordinatorEnrollment</option>
                        <option value="MerchantEnrollment">MerchantEnrollment</option>
                        <option value="PehchaanSetuChannel">PehchaanSetuChannel</option>
                        <option value="PehchaanSetuCircle">PehchaanSetuCircle</option>
                        <option value="StreakGift">StreakGift</option>
                        <option value="VocalForLocalDisplay">VocalForLocalDisplay</option>
                        <option value="Foundher">Foundher</option>
                        <option value="SHGAddon">SHGAddon</option>
                        <option value="MiniERPNoEDI">MiniERPNoEDI</option>
                        <option value="MiniERPEDI">MiniERPEDI</option>
                        <option value="EComStore">EComStore</option>
                        <option value="BestieStreaks">BestieStreaks</option>
                        <option value="AnvayaCarePlus">AnvayaCarePlus</option>
                        <option value="AnvayaCompleteCare">AnvayaCompleteCare</option>
                        <option value="AnvayaGrowth">AnvayaGrowth</option>
                        <option value="ToolKitSeed">ToolKitSeed</option>
                        <option value="ToolKitHer">ToolKitHer</option>
                        <option value="ToolKitEarlyGrowth">ToolKitEarlyGrowth</option>
                        <option value="ToolKitLeap">ToolKitLeap</option>
                        <option value="ToolKitFull">ToolKitFull</option>
                        <option value="NaboraExibitorPass">NaboraExibitorPass</option>
                        <option value="AddOnInstant">AddOnInstant</option>    
                        <option value="OtherServices">OtherServices</option> 
                    </select>
                </div>
                <div className="text-cyan-400 font-bold text-lg">
                    {productConfig[product]?.label} Subscription
                </div>

                <div className="text-xs text-gray-400 mt-1">
                    {productConfig[product]?.subtitle}
                </div>

                {activeSubscription?.product === product && (
                    <div className="flex-1 justify-center items mt-4 p-3 rounded border border-green-700 bg-green-900/20">
                        <div className="text-green-400 font-bold text-xs lg:text-sm">
                                ✅ There is Active Subscription of {product}
                        </div>
                        <div className="text-xs text-gray-300">
                            No renewal required at this time.
                        </div>
                        <div className="text-xs text-gray-300 mt-1">
                            Subscription ID:
                            {" "}
                            {activeSubscription.subscriptionId || "Pending"}
                        </div>

                        <div className="text-xs text-gray-300">
                            Valid Until:
                            {" "}
                            {new Date(
                                activeSubscription.endDate
                            ).toLocaleDateString()}
                        </div>
                    </div>
                )}

                <div className="mt-4">
                    <label className="block text-xs text-gray-400 mb-1">
                        Country
                    </label>

                    {authState?.user?.country ? (
                        <div className="w-full bg-[#1f2937] border border-gray-700 rounded px-2 py-2 text-xs lg:text-sm text-green-300 font-semibold">
                        🌍 {authState.user.country}
                        </div>
                    ) : (
                        <div className="w-full bg-red-500/10 border border-red-500 text-red-400 rounded px-2 py-2 text-xs lg:text-sm font-semibold">
                        ❌ Country is required. Go to SnapID and complete one-time country setup.
                        </div>
                    )}
                </div>
                <div className="mt-3 text-2xl font-bold text-green-400">
                    {selectedCountry?.symbol} {totalAmount.toFixed(2)}
                </div>

                <div className="mt-2 text-xs">
                    <span className="text-red-400 line-through mr-2">
                        {selectedCountry?.symbol}{(baseAmount / 0.6).toFixed(2)}
                    </span>
                    <span className="text-green-400 font-bold">
                        {selectedCountry?.symbol}{baseAmount.toFixed(2)}
                    </span>
                </div>

                {/* <div className="mt-2 text-xs text-gray-400">
                    Actual Price:
                    <span className="line-through ml-1">
                        {selectedCountry?.symbol} {(baseAmount / 0.6).toFixed(2)}
                    </span>
                </div>

                <div className="mt-2 text-xs text-gray-400">
                    Offered Base Price: {selectedCountry?.symbol} {baseAmount.toFixed(2)}
                </div> */}

                <div className="text-xs text-gray-400">
                    Tax:
                    {" "}
                    {(taxRate * 100).toFixed(0)}%
                </div>

                <div className="text-xs text-gray-400">
                    Currency:
                    {" "}
                    {selectedCountry?.symbol}
                </div>

                <div className="mt-1 text-[11px] text-gray-500">
                    Inclusive of Taxes, Financial Charges,
                    Currency Exchange Fee (if applicable)
                </div>

                {/* PAYMENT NOTICE */}
                <div className="mt-4 bg-yellow-900/40 border border-yellow-700 p-3 rounded text-xs text-yellow-200">
                    <div
                        className="
                            mb-4
                            rounded-2xl
                            border border-amber-500/30
                            bg-gradient-to-br
                            from-amber-950/30
                            via-orange-950/20
                            to-yellow-950/20
                            p-4
                            shadow-lg
                        "
                    >
                        <div className="flex items-center gap-2 mb-3">
                            <div className="text-xl">⚡</div>

                            <div>
                            <div className="font-bold text-amber-300">
                                Think5Whys FuelStash
                            </div>

                            <div className="text-[11px] text-gray-400">
                                Preferred Payment Wallet
                            </div>
                        </div>
                    </div>

                    <div
                        className="
                        rounded-xl
                        border border-cyan-500/20
                        bg-black/30
                        p-4
                        text-center
                        "
                    >
                        <div className="text-xs uppercase tracking-wider text-gray-400 mb-2">
                            Available Balance
                        </div>

                        <div
                            className={`text-3xl font-extrabold ${
                                walletBalance > 0
                                ? "text-green-400"
                                : "text-red-400"
                            }`}
                        >
                            {Number(walletBalance || 0).toFixed(2)}
                        </div>

                        <div className="mt-2 text-xs text-gray-400">
                            Use FuelStash balance for subscriptions, upgrades,
                            memberships, and platform services.
                        </div>
                    </div>

                    <div
                        className="
                        mt-3
                        rounded-xl
                        border border-yellow-500/20
                        bg-yellow-950/20
                        p-3
                        text-xs
                        text-yellow-100
                        text-center
                        "
                    >
                            ⚠️ Payments should be made using your{" "}
                            <span className="font-semibold text-yellow-300">
                            Think5Whys FuelStash
                            </span>{" "}
                            balance whenever applicable.
                    </div>
                </div>    
                <div className="flex flex-col justify-center items-center mt-2 mb-2">
                    {walletBalance >= totalAmount ? (
                        <span className="text-green-400 text-center">
                            ✅ You have sufficient balance to proceed with purchase.
                        </span>
                    ) : (
                        <span className="text-red-400 text-center">
                            ❌ Insufficient balance. Please top up your FuelStash to continue.
                        </span>
                    )}
                    <br />
                    { walletBalance < totalAmount && (
                        <div>
                            {paymentError && (
                                <div className="mb-3 rounded-xl border border-red-500/40 bg-red-950/40 p-4 shadow-lg">
                                    <div className="flex items-start gap-3">
                                        <div className="text-xl">⚠️</div>

                                        <div className="flex-1">
                                            <div className="font-semibold text-red-300 text-xs lg:text-sm">
                                                Payment Could Not Be Initiated
                                            </div>

                                            <div className="mt-1 text-red-200 text-xs leading-relaxed">
                                                {paymentError}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <button
                                disabled
                                // onClick={payWithRazorpay}
                                className="w-48 bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded text-xs"
                            >
                                Pay Online (UPI / Card)
                            </button>
                        </div>
                    )}
                </div>
                                       
                <PaymentNoticeBanner />
                <button
                    onClick={() =>
                    setShowCompanyDetails(!showCompanyDetails)
                    }
                    className="
                    w-full
                    rounded-xl
                    border border-cyan-500/30
                    bg-cyan-950/20
                    px-2 py-1
                    text-xs lg:text-sm font-semibold
                    text-cyan-300
                    hover:bg-cyan-950/40
                    transition-all
                    "
                >
                    {showCompanyDetails
                    ? "▲ Hide Company Information"
                    : "▼ View Company Information & Bank Details"}
                </button>

                {showCompanyDetails && (
                    <div className="mt-4">
                        <CompanyInfo />
                        <CompanyBankInfo />
                    </div>
                )}
                <button
                    onClick={() =>
                    setShowTnC(!showTnC)
                    }
                    className="
                    w-full
                    rounded-xl
                    border border-cyan-500/30
                    bg-cyan-950/20
                    px-2 py-1
                    text-xs lg:text-sm font-semibold
                    text-cyan-300
                    hover:bg-cyan-950/40
                    transition-all
                    "
                >
                    {showTnC
                    ? "▲ Hide Refund & Data Protection Policy"
                    : "▼ View Refund & Data Protection Policy"}
                </button>

                {showTnC && (
                    <div className="mt-4">
                        <SubscriptionTnC />
                    </div>
                )}
            </div>

            <div className="flex flex-col items-center gap-2 mt-4">
                <div className="rounded-xl border border-purple-500/30 bg-gradient-to-r from-purple-900/30 to-blue-900/20 p-2 shadow-md">
                    <div className="flex justify-center">
                        <button
                            disabled={walletBalance < totalAmount || baseAmount<=0 || showGiftRedeem}
                            onClick={() => {
                                setShowGiftForm(true);
                                setShowGiftRedeem(false);
                            }}
                            className="w-48 flex text-center justify-center gap-2 text-white px-3 py-2 rounded-lg text-xs bg-purple-600 hover:bg-purple-700 transition-all duration-200"
                        >
                            {/* <i className="fa-solid fa-gift text-sm"></i> */}
                            <span className="font-semibold tracking-wide">
                                🎁 Gift This Product
                            </span>
                        </button>
                    </div>
                    <p className="text-[11px] lg:text-xs text-gray-300 text-center mt-1">
                        Share this with someone special.
                        The recipient must not have an active subscription for this product.  
                        Gift subscriptions are exclusive — one product can only be assigned to one user per subscription cycle.  
                        Gift coupons are non-transferable, cannot be cancelled, and are non-refundable once issued.  
                        Once gifted, it is considered a completed purchase.                                
                    </p>
                </div>
            </div>
            {showGiftForm && (
                <div className="w-full">
                    <PDGiftIt
                        product={product}
                        paymentAmount={totalAmount}
                        onClose={() => setShowGiftForm(false)}
                    />
                </div>
            )}

            <div className="flex flex-col items-center gap-2 mt-4">
                <div className="w-full rounded-xl border border-purple-500/30 bg-gradient-to-r from-purple-900/30 to-blue-900/20 p-2 shadow-md">
                    <div className="flex justify-center">
                        <button
                            disabled={showGiftForm}
                            onClick={() => {
                                setShowGiftRedeem(true);
                            }}
                            className="w-48 flex items-center justify-center gap-2 text-white px-3 py-2 rounded-lg text-xs bg-blue-600 hover:bg-blue-700 transition-all duration-200"
                        >
                            {/* <i className="fa-solid fa-ticket text-sm"></i> */}
                            <span className="font-semibold tracking-wide">
                                🎁 Redeem Gift
                            </span>
                        </button>
                    </div>
                    <p className="text-xs text-center mt-2 font-medium text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 to-purple-300">
                        Unlock your gifted subscription with a valid coupon code
                    </p>
                </div>                      
{/* <div className="text-xs text-gray-300 bg-gray-900 p-3 rounded overflow-auto">
    <pre className="whitespace-pre-wrap break-all">
        {JSON.stringify(activeSubscription, null, 2)}
    </pre>
</div>    */}
                {showGiftRedeem && (
                    activeSubscription && activeSubscription.product === product ? (
                        <p className="text-[10px] text-gray-300 text-center mt-1">
                            You already have an active subscription for this product.  
                            Gift subscriptions are exclusive — one product can only be assigned to one user per subscription cycle.  
                            Gift coupons are non-transferable, cannot be cancelled, and are non-refundable once issued.  
                        </p>
                    ) : (
                        <div className="w-full">                           
                            <PDGiftRedeem
                                product={product}
                                countryCode={countryCode}
                                currency={currency}
                                purchasePayload={{
                                    product,
                                    userId: user._id,
                                    userCode: user.think5whyscode,
                                    userName: user.name,
                                    state: user.state,
                                    country: user.country,
                                    countryCode,
                                    currency,
                                    taxRate,
                                    baseAmount,
                                    totalAmount,
                                    isGifted: false,
                                    giftedByName,
                                    giftedByCode,
                                    giftedDate,
                                    giftMsg,
                                    institutionCode,
                                    coordinatorCode,
                                    directorCode,
                                    influencerCode,
                                }}
                                onClose={() => setShowGiftRedeem(false)}
                            />
                        </div>
                    )
                )}
            </div>

            <div className="space-y-3 text-left bg-gray-900 border border-purple-700 rounded-xl p-3 mt-2">
                <label className="flex items-start gap-2 text-xs lg:text-sm">
                    <input
                    type="checkbox"
                    name="nonRefundable"
                    disabled
                    checked                    
                    // checked={agreements.nonRefundable}
                    // onChange={handleAgreementChange}
                    className="mt-1"
                    />
                    <span>
                    I understand and agree that all subscription purchases are non-refundable once successfully processed.
                    </span>
                </label>

                <label className="flex items-start gap-2 text-xs lg:text-sm">
                    <input
                    type="checkbox"
                    name="technicalGlitches"
                    disabled
                    checked                    
                    // checked={agreements.technicalGlitches}
                    // onChange={handleAgreementChange}
                    className="mt-1"
                    />
                    <span>
                    I acknowledge that occasional technical glitches, network interruptions, payment gateway delays, or platform issues may occur and will be resolved as per company processes.
                    </span>
                </label>

                <label className="flex items-start gap-2 text-xs lg:text-sm">
                    <input
                    type="checkbox"
                    name="contestRules"
                    disabled
                    checked                    
                    // checked={agreements.contestRules}
                    // onChange={handleAgreementChange}
                    className="mt-1"
                    />
                    <span>
                    I have read, understood, and agree to abide by all contest, reward, campaign, and promotional rules announced by the company from time to time.
                    </span>
                </label>

                <label className="flex items-start gap-2 text-xs lg:text-sm">
                    <input
                    type="checkbox"
                    name="contestEligibility"
                    disabled
                    checked
                    // checked={agreements.contestEligibility}
                    // onChange={handleAgreementChange}
                    className="mt-1"
                    />
                    <span>
                    I understand that contest participation and contest-related benefits are applicable only to eligible product subscribers and may not be applicable to Directors, Coordinators, Influencers, or other categories as defined by the company.
                    </span>
                </label>

                <label className="flex items-start gap-2 text-xs lg:text-sm">
                    <input
                    type="checkbox"
                    name="directorCoordinatorKyc"
                    disabled
                    checked
                    // checked={agreements.directorCoordinatorKyc}
                    // onChange={handleAgreementChange}
                    className="mt-1"
                    />
                    <span>
                    If applying as a Director or Coordinator, I confirm that I meet the eligibility criteria and agree to provide KYC, identity, age, address, banking, tax, or any other verification documents requested by the company at onboarding or any future significant trigger points, including payouts, rewards, incentives, compliance reviews, or audits.
                    </span>
                </label>
            </div>

            {message?.text && !disablePurchase && (
                <div
                    className={`text-center mt-3 text-xs ${
                        message.type === "error"
                            ? "text-red-400"
                            : "text-green-400"
                    }`}
                >
                    {message.text}
                </div>
            )}

            {success && (
                <div className="flex-1 justify-center mt-3 text-xs text-green-400">
                    {success}
                </div>
            )}
            {isCountryMissing && (
            <div className="mt-3 text-xs text-red-400 bg-red-500/10 border border-red-500/20 rounded px-3 py-2">
                ⚠️ Your country is not set. Please go to SnapID and complete one-time country setup before purchasing.
            </div>
            )}
            {isStateMissing && (
            <div className="mt-3 text-xs text-red-400 bg-red-500/10 border border-red-500/20 rounded px-3 py-2">
                ⚠️ Your state/province/county is not set. Please go to SnapID and complete one-time state/province/county setup before purchasing.
            </div>
            )}
            {!activeSubscription && (
                <button
                    onClick={buy}
                    disabled={loading || showGiftForm || !allChecked || !config || disablePurchase || walletBalance < totalAmount || isCountryMissing || baseAmount<=0}
                    className={`w-full mt-4 px-3 py-1 rounded-lg text-xs lg:text-sm font-bold ${
                        loading || !config
                            ? "bg-gray-600 cursor-not-allowed"
                            : "bg-cyan-600 hover:bg-cyan-700"
                    }`}
                >
                    {
                        !config
                            ? "Loading Configuration..."
                            : loading
                                ? "Processing..."
                                : "Purchase Subscription"
                    }
                </button>
            )}
            </div>
        </div>
    );
}